const COLLAB_PATH = 'ccollab'; // the extra c is for Confluence

export const getCollabProviderUrl = () => {
	return `${window.location.origin}/${COLLAB_PATH}`;
};

/**
 * Gets the sharded routing path to call collab edit service via PMR
 *
 * @param cloudId - The cloud ID
 * @param activationId - The activation ID
 * @returns {string} The sharded routing path for edit traffic
 */
export const getCollabEditServicePath = (cloudId: string, activationId: string): string => {
	const editPrefix = '/ncs';
	return `${editPrefix}/${cloudId}/${activationId}/confluence`;
};
